export const DEFAULT_SCROLL_VALUE = 0;
export const ELEMENTS_GAP = 10;
export const INITIAL_CONTAINER_WIDTH = 1200;
export const INITIAL_ELEMENTS_COUNT = 7;

export enum ELEMENT_TYPES {
    dummy,
    element,
    empty
}
